import script from "./EditCompanyMatricule.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditCompanyMatricule.vue?vue&type=script&lang=ts&setup=true"

import "./EditCompanyMatricule.vue?vue&type=style&index=0&id=4e25a582&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e25a582"]])

export default __exports__